import { AGENT_FALLBACK_URL } from "utils/constants";
import { isEmpty } from "utils/helpers";

interface IAgentInfoCardProps {
    agentProfileUrl?: string;
    brokerProfileUrl?: string;
    photo: string;
    name: string;
    officeName: string;
    mlsPlantinum?: string;
    isTextTruncate?: boolean;
}

export const AgentInfoCard = (props: IAgentInfoCardProps): JSX.Element => {
    const { agentProfileUrl, photo, name, officeName, brokerProfileUrl, mlsPlantinum, isTextTruncate } = props;
    const viewNameProfile = `View ${name} profile`;
    const viewOfficeNamePage = `View ${officeName} page`;
    const agentProfileUrlFinal = agentProfileUrl || AGENT_FALLBACK_URL;

    return (
        <div className="agent_signaturev2">
            <a href={agentProfileUrlFinal}
                target="_blank"
                rel="noopener noreferrer"
                title={viewNameProfile}
                onClick={e => e.stopPropagation()}
            >
                <div className="agent_signaturev2__photo"
                    style={{
                        backgroundImage: `url(${!isEmpty(photo)
                            ? photo
                            : "https://content.harstatic.com/media/icons/a_all/agent_placeholder_square.svg"
                            }`,
                    }}
                />
            </a>
            <div className="agent_signaturev2__info" style={{ lineHeight: "normal" }}>
                <div className="agent_signaturev2__info__agent_name"
                    title={viewNameProfile}
                    style={isTextTruncate ? {} : { textOverflow: 'initial' }}
                >
                    <a href={agentProfileUrlFinal}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="agent_signaturev2__info__agent_name mb-1"
                        onClick={e => e.stopPropagation()}
                    >{name} {" "}
                        {mlsPlantinum === "1" ? (
                            <img
                                alt="Platinum Agent"
                                style={{ width: '75px' }}
                                src="https://content.harstatic.com/media/icons/label-platinum.svg"
                            />
                        ) : null}
                    </a>
                </div>

                <a {...brokerProfileUrl ? { href: `https://www.har.com${brokerProfileUrl}` } : {}}
                    className="agent_signaturev2__info__broker_name"
                    style={{ fontWeight: 'normal', ...(isTextTruncate ? {} : { textOverflow: 'initial' }) }}
                    {...brokerProfileUrl ? { title: viewOfficeNamePage, target: "_blank", rel: 'noopener noreferrer' } : {}}
                    onClick={e => e.stopPropagation()}
                >{officeName}
                </a>
            </div>
        </div>
    )
}
